import React from "react";
export const AuthContext = React.createContext();
export const DialogContext = React.createContext();
export const JoySnackBarContext = React.createContext();
export const TranslationContext = React.createContext();
export const GlobalContext = React.createContext();
